import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "ObjectStorage"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", { d: "M21 15H19.5V16.5H21V21H3V16.5H10.5V15H3C2.60232 15.0005 2.22105 15.1586 1.93984 15.4398C1.65864 15.721 1.50046 16.1023 1.5 16.5V21C1.50046 21.3977 1.65864 21.779 1.93984 22.0602C2.22105 22.3414 2.60232 22.4995 3 22.5H21C21.3977 22.4995 21.7789 22.3414 22.0602 22.0602C22.3414 21.779 22.4995 21.3977 22.5 21V16.5C22.4995 16.1023 22.3414 15.721 22.0602 15.4398C21.7789 15.1586 21.3977 15.0005 21 15Z" }, null, -1);
const _hoisted_3 = /* @__PURE__ */ _createElementVNode("path", { d: "M5.25 19.5C5.66421 19.5 6 19.1642 6 18.75 6 18.3358 5.66421 18 5.25 18 4.83579 18 4.5 18.3358 4.5 18.75 4.5 19.1642 4.83579 19.5 5.25 19.5zM22.5 6H16.5V10.5H12V16.5H18V12H22.5V6zM16.5 15H13.5V12H16.5V15zM21 10.5H18V7.5H21V10.5zM13.5 7.5H7.5V1.5H13.5V7.5zM9 6H12V3H9V6z" }, null, -1);
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/ObjectStorage.vue"]]);
